import { db } from '../firebase';
import { collection, addDoc } from "firebase/firestore"; 

// Función para subir un registro a la colección "logs" en Firestore
export const uploadLogToFirestore = async (logContent) => {
    try {
        const timestamp = new Date();

        // Referencia a la colección "logs" en Firestore
        const logsCollectionRef = collection(db, 'logs');

        // Agrega el registro a la colección "logs"
        await addDoc(logsCollectionRef, {
            timestamp: timestamp,
            content: logContent,
            logtype: 'info',
        });


        console.log('Log uploaded to Firestore.');
    } catch (error) {
        console.error('Error uploading log to Firestore:', error);
    }
};

// Función para subir un registro a la colección "logs" en Firestore
export const uploadErrorLogToFirestore = async (logContent) => {
    try {
        const timestamp = new Date();

        // Referencia a la colección "logs" en Firestore
        const logsCollectionRef = collection(db, 'logs');

        // Agrega el registro a la colección "logs"
        await addDoc(logsCollectionRef, {
            timestamp: timestamp,
            content: logContent,
            logtype: 'error',
        });


        console.log('Log uploaded to Firestore.');
    } catch (error) {
        console.error('Error uploading log to Firestore:', error);
    }
};

/**
 * Función para subir logs de profiling/rendimiento a Firestore
 * @param {Object} profilingData - Datos del profiling
 * @param {string} profilingData.operation - Nombre de la operación (ej: 'download', 'search')
 * @param {number} profilingData.totalTimeMs - Tiempo total en milisegundos
 * @param {number} profilingData.itemsProcessed - Cantidad de items procesados
 * @param {Object} profilingData.measurements - Mediciones detalladas por fase
 * @param {Object} profilingData.metadata - Metadatos adicionales
 */
export const uploadProfilingLogToFirestore = async (profilingData) => {
    try {
        const timestamp = new Date();

        // Referencia a la colección "logs" en Firestore
        const logsCollectionRef = collection(db, 'logs');

        // Formatear el contenido del log para que sea legible
        const formattedContent = formatProfilingContent(profilingData);

        // Agrega el registro a la colección "logs"
        await addDoc(logsCollectionRef, {
            timestamp: timestamp,
            content: formattedContent,
            logtype: 'profiling',
            operation: profilingData.operation || 'unknown',
            totalTimeMs: profilingData.totalTimeMs || 0,
            totalTimeSeconds: profilingData.totalTimeMs ? (profilingData.totalTimeMs / 1000).toFixed(2) : 0,
            itemsProcessed: profilingData.itemsProcessed || 0,
            itemsPerSecond: profilingData.totalTimeMs && profilingData.itemsProcessed 
                ? (profilingData.itemsProcessed / (profilingData.totalTimeMs / 1000)).toFixed(2) 
                : 0,
            measurements: profilingData.measurements || {},
            metadata: profilingData.metadata || {},
            performanceLevel: getPerformanceLevel(profilingData.totalTimeMs),
        });

        console.log('📊 Profiling log uploaded to Firestore:', profilingData.operation);
    } catch (error) {
        console.error('Error uploading profiling log to Firestore:', error);
    }
};

/**
 * Determina el nivel de rendimiento basado en el tiempo total
 * @param {number} totalTimeMs - Tiempo total en milisegundos
 * @returns {string} - Nivel de rendimiento
 */
function getPerformanceLevel(totalTimeMs) {
    if (!totalTimeMs) return 'unknown';
    if (totalTimeMs < 1000) return 'excellent';
    if (totalTimeMs < 5000) return 'good';
    if (totalTimeMs < 15000) return 'acceptable';
    if (totalTimeMs < 30000) return 'slow';
    return 'very_slow';
}

/**
 * Formatea los datos de profiling en un string legible
 * @param {Object} profilingData - Datos del profiling
 * @returns {string} - Contenido formateado
 */
function formatProfilingContent(profilingData) {
    const lines = [];
    
    lines.push(`📊 PROFILING: ${profilingData.operation?.toUpperCase() || 'OPERACIÓN'}`);
    lines.push(`═══════════════════════════════════════`);
    
    if (profilingData.totalTimeMs) {
        const seconds = (profilingData.totalTimeMs / 1000).toFixed(2);
        lines.push(`⏱️ Tiempo total: ${seconds}s (${profilingData.totalTimeMs.toFixed(0)}ms)`);
    }
    
    if (profilingData.itemsProcessed) {
        lines.push(`📄 Items procesados: ${profilingData.itemsProcessed}`);
        
        if (profilingData.totalTimeMs) {
            const speed = profilingData.itemsProcessed / (profilingData.totalTimeMs / 1000);
            lines.push(`🚀 Velocidad: ${speed.toFixed(2)} items/segundo`);
        }
    }
    
    lines.push(`📈 Rendimiento: ${getPerformanceLevel(profilingData.totalTimeMs).toUpperCase()}`);
    
    // Agregar mediciones detalladas si existen
    if (profilingData.measurements && Object.keys(profilingData.measurements).length > 0) {
        lines.push(`\n📋 DESGLOSE POR FASE:`);
        lines.push(`───────────────────────────────────────`);
        
        Object.entries(profilingData.measurements).forEach(([phase, data]) => {
            if (data.durationMs) {
                const percentage = profilingData.totalTimeMs 
                    ? ((data.durationMs / profilingData.totalTimeMs) * 100).toFixed(1) 
                    : 0;
                lines.push(`  • ${phase}: ${data.durationMs.toFixed(0)}ms (${percentage}%)`);
            }
        });
    }
    
    // Agregar metadatos si existen
    if (profilingData.metadata && Object.keys(profilingData.metadata).length > 0) {
        lines.push(`\n📝 METADATOS:`);
        lines.push(`───────────────────────────────────────`);
        
        Object.entries(profilingData.metadata).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                lines.push(`  • ${key}: ${typeof value === 'object' ? JSON.stringify(value) : value}`);
            }
        });
    }
    
    lines.push(`═══════════════════════════════════════`);
    
    return lines.join('\n');
}